import { useGetSinglePickingPositionQuery } from '../../../apiCalculationDetail';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { SkuRedistributionResponse } from '@ydistri/api-sdk';
import { usePickingPositionParamsFromUrl } from './usePickingPositionParamsFromUrl';
import { useStableComputedValue } from '../../../../../hooks/useStableComputedValue';

export const useSelectedPickingPositionFromUrl = (): SkuRedistributionResponse | undefined => {
  const pickingPositionParams = usePickingPositionParamsFromUrl();

  const params = useMemo(() => pickingPositionParams ?? skipToken, [pickingPositionParams]);

  const { data, isFetching } = useGetSinglePickingPositionQuery(params);

  const stableData = useStableComputedValue(() => data, isFetching, [data]);

  if (pickingPositionParams) return stableData;
  return undefined;
};
